<div nz-row nzType="flex">
  <div nz-col nzSpan="7">
    <div style="font-size: 13px;"  class="formname">{{ formTitle }}</div>
  </div>

  <div nz-col nzSpan="17" style="display: flex; justify-content: flex-end">
    <form nz-form [nzLayout]="'inline'">
      <nz-form-item>
        <nz-form-control>
          <nz-date-picker
            [(ngModel)]="month"
            style="width: 100% ; font-size: 11px !important; "
            nzFormat="MMM yyyy"
            name="selectMonth2"
            nzPlaceHolder="Select month"
            (ngModelChange)="yearChange($event)"
            nzMode="month"
            [nzDisabledDate]="disabledDate"
          >
          </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
      <!-- <nz-form-item>
        <nz-form-control>
          <nz-range-picker
            [(ngModel)]="selectedRange"
            style="width: 70%; font-size: 11px !important;"
            nzFormat="yyyy-MM-dd"
            name="selectRange"
            nzPlaceHolder="Select start and end date"

            nzPlaceHolder="Select date range"
            (ngModelChange)="onRangeChange($event)"
            [nzDisabledDate]="disabledDate"
          >
          </nz-range-picker>
        </nz-form-control>
      </nz-form-item> -->
      

      <nz-form-item>
        <button
          [nzLoading]="loadingRecords"
          nz-button
          nzType="primary"
          style="margin-right: 0px"
          (click)="fireEvent()"
          [nzLoading]="loadprojectexcel"
        >
          <i nz-icon nzType="file-excel" nzTheme="outline"></i>
        </button>
      </nz-form-item>

      <nz-form-item style="margin-right: 0px">
        <button
          nz-button
          *ngIf="FinalalizeKey == 0"
          nzType="primary"
          [nzLoading]="loadingRecords"
          (click)="save()"
          style="font-size: 11px;"
        >
          Push Data 
        </button>
      </nz-form-item>
    </form>
  </div>
</div>

<div nz-row>
  <div nz-col nzSpan="24">
    <!-- <nz-table #table class="my-scroll no-wrap1" nzBordered nzShowSizeChanger [nzFrontPagination]="false"
      [nzData]="employeeData" [nzLoading]="loadingRecords"
      nzSize="small"> -->
    <!-- <nz-table
      class="my-scroll no-wrap1"
      nzBordered
      #postTable
      nzShowSizeChanger
      [nzFrontPagination]="false"
      [nzData]="dataList"
      [nzLoading]="loadingRecords"
      [nzSize]="'small'"
      [nzTotal]="totalRecords"
      [(nzPageIndex)]="pageIndex"
      [(nzPageSize)]="pageSize"
      (nzPageIndexChange)="search()"
      (nzPageSizeChange)="search(true)"
      (nzQueryParams)="sort($event)"
      [nzScroll]="{ x: '900px', y: '55vh' }"
    > -->

    <nz-table
    #table
    nzBordered
    [nzData]="employeeData"
    [nzLoading]="loadingRecords"
    [nzFrontPagination]="false"
    nzSize="small"
    [nzScroll]="scroll"
  >
    <thead>
      <tr>
        <th nzLeft style="text-align: center; padding: 2px;  " [rowSpan]="2" nzWidth="160px">
          <b style="font-size:12px !important">Employee Name</b>
        </th>
        <th style="text-align: center; padding: 2px;  " [rowSpan]="2" nzWidth="100px">
          <b style="font-size:12px !important">Rate</b>
        </th>
        <th *ngFor="let project of maxColumns" style="text-align: center; white-space: pre-line; padding: 2px;" [colSpan]="2" >
          <b style=" font-size:12px !important ;white-space: pre-line; overflow: hidden; text-overflow: ellipsis; text-align: left;" nz-tooltip
            [nzTooltipTitle]="employeeData[0]?.P[project - 1]?.PROJECT_NAME || 'No Project Name'">
            {{
              (employeeData[0]?.P[project - 1]?.PROJECT_NAME?.length > 15
                ? employeeData[0]?.P[project - 1]?.PROJECT_NAME.slice(0, 15) + '...'
                : employeeData[0]?.P[project - 1]?.PROJECT_NAME) || 'Project' + project
            }}
          </b>
        </th>
        <th style="text-align: center; padding: 2px;  " [rowSpan]="2" nzWidth="140px" nzRight>
          <b style="font-size:12px !important">Total Amount</b>
        </th>
        <th style="text-align: center; padding: 2px;  " [rowSpan]="2" nzWidth="140px" nzRight>
          <b style="font-size:12px !important">Total Hours</b>
        </th>
        <th style="text-align: center; padding: 2px;  " [rowSpan]="2" nzWidth="140px" nzRight>
          <b style="font-size:12px !important">Total Days</b>
        </th>
        
      </tr>
      <tr>
        <ng-container *ngFor="let project of maxColumns">
          <th style="text-align: center; padding: 2px;  " >
            <b style="font-size:12px !important">TIME</b>
          </th>
          <th style="text-align: center; padding: 2px;  " >
            <b style="font-size:12px !important">AMOUNT</b>
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let employee of employeeData; let last = last" [ngClass]="{ 'totals-row': last }">
        <!-- Tooltip for EMP_NAME -->
        <td nzLeft style="white-space: pre-line; text-align: left; padding: 2px;"
          nz-tooltip [nzTooltipTitle]="employee.EMP_NAME  ">
          {{ employee.EMP_NAME?.length > 5 ? employee.EMP_NAME.slice(0, 30) : employee.EMP_NAME }}
        </td>
    
        <td    nz-tooltip [nzTooltipTitle]="employee.RATE_PER_HOUR | number: '1.2-2'"  style="white-space: pre-line; text-align: right; padding: 2px;" >
          {{ employee.RATE_PER_HOUR | number: '1.2-2' }}
        </td>
        
        <ng-container *ngFor="let projectIndex of maxColumns">
          <td style="white-space: nowrap; text-align: center; overflow: hidden; text-overflow: ellipsis; padding: 2px;" 
            nz-tooltip [nzTooltipTitle]="employee.P[projectIndex - 1]?.TIME">
            {{
              (employee.P[projectIndex - 1]?.TIME?.length > 5
                ? employee.P[projectIndex - 1]?.TIME.slice(0, 8)
                : employee.P[projectIndex - 1]?.TIME)
            }}
          </td>
          <td style="white-space: nowrap; text-align: right; overflow: hidden; text-overflow: ellipsis; padding: 2px;" 
    nz-tooltip 
    [nzTooltipTitle]="employee.P[projectIndex - 1]?.AMOUNT | number: '1.2-2'">
    <!-- <label for="">{{projectIndex}} {{}}</label> -->
  {{
    employee.P[projectIndex - 1]?.AMOUNT != null
      ? (employee.P[projectIndex - 1]?.AMOUNT | number: '1.2-2')
      : '-'
  }}
</td>

        </ng-container>
        
        <!-- Tooltip for TOTAL_AMOUNT -->
        <td style="white-space: pre-line; text-align: right; padding: 2px;"  nzRight
        nz-tooltip [nzTooltipTitle]="employee.TOTAL_AMOUNT?.toString().length > 10 ? employee.TOTAL_AMOUNT : employee.TOTAL_AMOUNT">
          {{ employee.TOTAL_AMOUNT?.toString().length > 10 ? employee.TOTAL_AMOUNT.toString().slice(0, 10) : employee.TOTAL_AMOUNT | number: '1.2-2' }}
        </td>
    
        <!-- Tooltip for TOTAL_HOURS -->
        <td style="white-space: pre-line; text-align: center; padding: 2px;"  nzRight
            nz-tooltip [nzTooltipTitle]="employee.TOTAL_HOURS?.length > 10 ? employee.TOTAL_HOURS : employee.TOTAL_HOURS ">
          {{ employee.TOTAL_HOURS?.length > 10 ? employee.TOTAL_HOURS.slice(0, 10) : employee.TOTAL_HOURS }}
        </td>
    
        <!-- Tooltip for TOTAL_DAYS -->
        <td style="white-space: pre-line; text-align: center; padding: 2px;"  nzRight
            nz-tooltip [nzTooltipTitle]="employee.TOTAL_DAYS?.toString().length > 10 ? employee.TOTAL_DAYS : employee.TOTAL_DAYS">
          <label for=""> {{TOTAL_DAYS}}</label>
          {{ employee.TOTAL_DAYS?.toString().length > 10 ? employee.TOTAL_DAYS.toString().slice(0, 10) : employee.TOTAL_DAYS }}
        </td>
      </tr>
    </tbody>
    
  </nz-table>
  
  
  
  
  </div>
</div>

<nz-modal
  [nzBodyStyle]="{ height: '500px' , padding : '6px'  }"
  class="modal-css"
  [nzClosable]="true"
  [(nzVisible)]="isVisible"
  nzWidth="45%"
  (nzOnCancel)="handleCancel()"
  [nzFooter]="modalFooter"
  nzTitle="Update Project Sequence"
  [nzClosable]="false"
  
>
  <ng-template #modalFooter>
    <button
      type="button"
      nz-button
      class="ant-btn"
      style=" font-size: 11px  ;margin-right: 8px;  padding: 1px 6px;"
      [nzLoading]="isSpinning"
      (click)="handleCancel()"
    >
      <span>Cancel</span>
    </button>
    <button
      nz-button
      nzType="primary"
      (click)="save()"
      style=" font-size: 11px  ; padding: 1px 6px;"
      [nzLoading]="isConfirmLoading"
    >
      <span>Save & Close</span>
    </button>
  </ng-template>

  <ng-container *nzModalContent>
    <div nz-row style="overflow-y: auto; overflow-x: hidden; height: 490px">
      <div nz-col nzSpan="24">
        <div class="nx-card-container" #projectListContainer>
          <div
            *ngFor="let project of projectList; let i = index"
            class="project-item"
            draggable="true"
            (dragstart)="onDragStart($event, project, i)"
            (dragover)="onDragOver($event)"
            (drop)="onDrop($event, i)"
            (dragend)="onDragEnd($event)"
            [attr.data-index]="i"
          >
            <!-- Your project content here -->
            <span
              style="
                padding: 4px 13px;
                border-radius: 5px;
                background-color: #c0dff4;
                margin-right: 12px;
                width: 60px;
                text-align: center;
              "
              >{{ i + 1 }}</span
            >
            <span style="padding: 4px 13px; border-radius: 5px">
              {{ project.NAME }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
